import React from "react";

function PaymentResultPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Спасибо за оплату</h1>
      <p>Если что-то пошло не так, свяжитесь с нами.</p>
      {/* Можно позже сюда добавить проверку статуса по payment_id */}
    </div>
  );
}

export default PaymentResultPage;
